/**
 * 前端 step-up 状态。
 *
 * - 内存里保存一枚 step-up 令牌(10min 有效),adminApi 请求拦截器自动带 X-Step-Up。
 * - 一个由全局 <StepUpModal/> 注册的「索要令牌」回调:撞到 STEP_UP_REQUIRED 时,
 *   adminApi 响应拦截器调它弹 TOTP(必要时先绑 MFA)→ 拿到令牌 → 重试原请求。
 */

let token: string | null = null;

export function getStepUpToken(): string | null {
  return token;
}
export function setStepUpToken(t: string | null): void {
  token = t;
}

/** 弹框索要:返回新的 step-up 令牌;用户取消返回 null。 */
export type StepUpPrompt = () => Promise<string | null>;

let prompt: StepUpPrompt | null = null;

export function registerStepUpPrompt(p: StepUpPrompt | null): void {
  prompt = p;
}
export function getStepUpPrompt(): StepUpPrompt | null {
  return prompt;
}
